import {checkIfKnownGroundBackground} from '../../configs/groundBackgrounds';

/**
 * Подложка поля локальной партии. По старшинству:
 *  1. выбор игрока на странице настройки партии (HotSeatPlayersInitPage) —
 *     игрок назвал подложку сам;
 *  2. своя подложка поля, если она записана в его файле;
 *  3. подложка партии — случайная, разыгранная один раз до загрузки поля.
 *
 * И выбор игрока, и подложка поля сверяются с перечнем подложек: незнакомый
 * идентификатор (подложку сняли с раздачи, а выбор остался в localStorage или
 * в файле поля) пропускается. Иначе он попал бы в состояние и в запись матча,
 * сцена молча нарисовала бы случайную подложку, а запись при каждом просмотре
 * — другую.
 *
 * @param {Object} params
 * @param {string|null} [params.chosenGroundBackground] — выбор игрока; null — «Случайная»
 * @param {string|null} [params.fieldGroundBackground] — подложка из файла поля
 * @param {string} params.partyGroundBackground — случайная подложка партии
 * @returns {string}
 */
export const resolveLocalMatchGroundBackground = ({
  chosenGroundBackground = null,
  fieldGroundBackground = null,
  partyGroundBackground,
} = {}) => (
  [chosenGroundBackground, fieldGroundBackground].find(checkIfKnownGroundBackground) ?? partyGroundBackground
);
